import React from 'react';
import { useDispatch } from 'react-redux';
import { MediaBaseUrl } from '../../../../../actions/api';
import { createFeed } from '../../../../../utils';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';
import { Button, Image } from 'react-bootstrap';

const ManageFeedEmpty = () => { 
  const dispatch = useDispatch();
  return (
    <div className="add-feed-modal-body mCustomScroll">
      <div className="container">
        <div id="feed_content__"><div className="py-5">
          <div className="contntManageFeeds feedWrapC mb-3">
            <div className="card card-custom">
              <div className="card-header flex-wrap py-3">
                <div className="card-title">
                  <h3 className="card-label">Feed List</h3>
                </div>
                <div className="card-toolbar">
                  <Button variant='primary' onClick={()=>createFeed(dispatch)}>
                    <FontAwesomeIcon type={'regular'} icon={'plus'} iconClass={'me-2'} />
                    Add Feed
                  </Button>
                </div>
              </div>
              <div className="card-body pt-3 pb-3 px-4">
                <div className="table-scrollable globalTblList">
                  <div className="f-center flex-column py-5" style={{ minHeight: 'calc(100vh - 320px)' }}>
                    <Image src={`${MediaBaseUrl}error/drop-box.svg`} className="img-fluid my-5" style={{ width: '200px' }} />
                    <h5>Oops! Nothing found</h5>
                    <div className="buttonUpgred pb-5">
                      <Button variant='primary' type="button" onClick={()=>createFeed(dispatch)} id="initCreateFeed" className="mt-4">
                      <FontAwesomeIcon type={'regular'} icon={'plus'} iconClass={'me-2'} /> Add Feed</Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div className="tab-content errorManageFeeds" style={{ display: 'none' }}>
            <div className="col-lg-12">
              <div className="upgredeMain">
                <div className="Errorimage"><img src={`${MediaBaseUrl}error/menual-icon.svg`} style={{ width: '100px' }} /></div>
                <div className="permissionMsg">
                  <span className="ErrorMsg">Unable to use Manual Moderation?</span>
                  <p className="msgSec">Oops! Looks like you need to upgrade your plan in order to use Manual Moderation</p>
                </div>
                <div className="buttonUpgred mb-3">
                  <a href="javascript:;" className="commanBtn btn-md" onclick="javascript:$('.FeedModal').modal('hide');showpricing(2,'Commerce','commerce');">
                    Upgrade Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
};

export default ManageFeedEmpty;